// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:49:24

export default {
  "id": "spider-noob-obstacle-course",
  "slug": "spider-noob-obstacle-course",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/75be36a35a6e4c298be61a0b8c229a97-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/75be36a35a6e4c298be61a0b8c229a97/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Spider-Noob obstacle course",
      "description": "Noob was bitten by a creeper-spider and became a spider-noob! Help Noob train in the big city, fly on webs, collect badges, unlock new costumes, and complete challenges. Unlock new levels. \n\nComplete all the levels and turn Noob into a Pro-spider",
      "instructions": "The game features very simple controls, with badges scattered throughout the level. When near a badge, hold down the tap or mouse button to grab onto it, then release at the right time to continue your flight.\n\nThere is also a hidden icon on each level, see if you can find it.\n\nEach badge collected earns points, try to collect as many as possible on each level.\n\nUse your points and badges to purchase new costumes for Nubika, try to collect them all.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "arcade",
        "minecraft",
        "spiderman"
      ]
    },
    "zh-CN": {
      "title": "蜘蛛菜鸟障碍赛道",
      "description": "菜鸟被爬行者蜘蛛咬了，变成了蜘蛛菜鸟！帮助菜鸟在大城市训练，飞蛛网，收集徽章，解锁新服装，并完成挑战。解锁新关卡。\n\n完成所有关卡，将菜鸟变成专业蜘蛛",
      "instructions": "游戏操作非常简单，关卡中散布着徽章。靠近徽章时，按住点击或鼠标按钮抓住它，然后在正确的时间松开以继续飞行。\n\n每个关卡都有一个隐藏的图标，看看你是否能找到它。\n\n收集到的每个徽章都能获得分数，尽量在每关收集尽可能多的徽章。\n\n使用你的分数和徽章为Nubika购买新服装，尽量收集它们全部。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "街机",
        "我的世界",
        "蜘蛛侠"
      ]
    },
    "zh-TW": {
      "title": "蜘蛛新手挑戰賽道",
      "description": "Noob 被爬行者蜘蛛咬傷，變成了蜘蛛新手！幫助 Noob 在大都市接受訓練，在蜘蛛絲上飛翔，收集徽章，解鎖新裝扮，並完成挑戰。解鎖新關卡。\n\n完成所有關卡，將 Noob 讓成專業蜘蛛",
      "instructions": "遊戲具有非常簡單的操作，徽章散布於整個關卡中。當靠近徽章時，按住觸控或滑鼠按鈕來抓住它，然後在適當的時機釋放以繼續飛行。\n\n每個關卡還隱藏著一個圖標，試著找找看能不能找到。\n\n每收集到一個徽章都能獲得分數，試著在每個關卡中盡量收集更多。\n\n使用你的分數和徽章來購買新的Nubika服裝，試著收集他們全部。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "電玩遊戲",
        "麵包團",
        "蜘蛛俠"
      ]
    },
    "zh-HK": {
      "title": "蜘蛛新手挑戰賽道",
      "description": "新手被爬行者蜘蛛咬了，變成了蜘蛛新手！幫助新手在大城市訓練，在網絡上飛行，收集獎章，解鎖新裝扮，並完成挑戰。解鎖新關卡。\n\n完成所有關卡，將新手變成專業蜘蛛",
      "instructions": "遊戲具有非常簡單的操作，獎章散布於整個關卡之中。當接近獎章時，按住滑鼠左鍵或點擊鍵以抓取它，然後在正確的時機釋放以繼續飛行。\n\n每個關卡還隱藏了一個圖示，看看你能否找到它。\n\n收集到的每個獎章都會獲得分數，盡量在每個關卡中收集盡可能多的獎章。\n\n使用你的分數和獎章來購買Nubika的新裝扮，盡量收集全部。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "街機",
        "我的世界",
        "蜘蛛俠"
      ]
    },
    "ja": {
      "title": "スパイダーノーボー障害コース",
      "description": "ノブがクリーパースパイダーに噛まれ、スパイダーノブに変身した！ノブを大都市で訓練し、ウェブで飛び回り、バッジを収集し、新しいコスチュームを解除し、チャレンジを完了させよう。新しいレベルを解除する。\n\nすべてのレベルを完了し、ノブをプロスパイダーに変える",
      "instructions": "ゲームは非常にシンプルな操作で、レベル全体にバッジが散らばっています。バッジの近くに来たら、タップまたはマウスボタンを押してそれを取るようにし、正しいタイミングでリリースして飛行を続けます。\n\n各レベルには隠されたアイコンがあります。見つけられるか試してみてください。\n\n収集した各バッジでポイントがもらえます。各レベルでできるだけ多く収集しようとしましょう。\n\nポイントとバッジを使ってNubikaの新しいコスチュームを購入し、すべてを収集しようとしましょう。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "アーケード",
        "マインクラフト",
        "スパイダーマン"
      ]
    },
    "ko": {
      "title": "스파이더-노브 장애물 코스",
      "description": "노브가 크리퍼-스파이더에 물려蜘蛛노브가 되었습니다! 대도시에서 노브를 훈련시키고, 그물을 타고 날아다니며 배지를 모으고, 새로운 복장을 해금하고, 도전을 완료하세요. 새로운 레벨을 해금하세요.\n\n모든 레벨을 완료하여 노브를 프로스파이더로 만들어보세요.",
      "instructions": "게임은 매우 간단한 조작을 특징으로 하며, 레벨 전체에 뿌려져 있는 배지가 있습니다. 배지 근처에 가까워지면 탭이나 마우스 버튼을 누르고 그것을 잡아당겨, 적절한 시기에 풀어놓아 비행을 계속하세요.\n\n각 레벨마다 숨겨진 아이콘도 있습니다. 그것을 찾아보세요.\n\n많은 배지를 모으면 점수를 얻습니다. 각 레벨에서 가능한 많이 모으세요.\n\n점수와 배지를 사용하여 Nu-bika의 새로운 의상을 구매하세요. 모두를 모으세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "아케이드",
        "마인크래프트",
        "스파이더맨"
      ]
    },
    "fr": {
      "title": "Course d'obstacles Spider-Noob",
      "description": "Noob a été mordu par une crépère-araignée et est devenu un araignée-noob ! Aidez Noob à s'entraîner dans la grande ville, voler sur des toiles, collecter des badges, déverrouiller de nouveaux costumes et accomplir des défis. Débloquez de nouveaux niveaux.\n\nTerminez tous les niveaux et transformez Noob en un Pro-araignée.",
      "instructions": "Le jeu présente des contrôles très simples, avec des médailles disséminées à travers le niveau. Lorsque vous êtes près d'une médaille, appuyez sur le tap ou le bouton de la souris pour l'attraper, puis relâchez à l'instant opportun pour continuer votre vol.\n\nIl y a également un icône caché sur chaque niveau, voyez si vous pouvez le trouver.\n\nChaque médaille collectée rapporte des points, essayez de collecter le plus possible sur chaque niveau.\n\nUtilisez vos points et vos médailles pour acheter de nouveaux costumes pour Nubika, essayez de les collectionner tous.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "arcade",
        "Minecraft",
        "Spider-Man"
      ]
    }
  }
};
